(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_video_section"] && !Shopify.designMode) return;
  try {
    
class VideoCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.vc-track');
    this.cards = container.querySelectorAll('.video-card');
    this.prevBtn = container.querySelector('.vc-prev');
    this.nextBtn = container.querySelector('.vc-next');
    
    this.isHovering = false;
    this.currentPlayingCard = null;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.init();
  }

  init() {
    // 1. Hover & Click Interactions
    this.cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        if (this.isDown) return;
        this.isHovering = true;
        this.playCard(card);
      });
      
      card.addEventListener('mouseleave', () => {
        this.isHovering = false;
      });

      // Mobile Tap Support
      card.addEventListener('click', () => {
        if(!this.isDown) this.playCard(card);
      });
    });

    // 2. Intersection Observer (Auto Play Center)
    this.observer = new IntersectionObserver((entries) => {
      if (this.isHovering || this.isDown) return;

      const visibleEntries = entries.filter(entry => entry.isIntersecting);
      if (visibleEntries.length > 0) {
        this.findAndPlayCenter(visibleEntries);
      }
    }, { root: this.track, threshold: 0.6 });

    this.cards.forEach(card => this.observer.observe(card));

    // 3. Navigation Buttons
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll(-1));
      this.nextBtn.addEventListener('click', () => this.scroll(1));
    }

    // 4. Drag to Scroll
    this.track.addEventListener('mousedown', (e) => this.startDrag(e));
    this.track.addEventListener('mouseleave', () => this.stopDrag());
    this.track.addEventListener('mouseup', () => this.stopDrag());
    this.track.addEventListener('mousemove', (e) => this.drag(e));
    
    // Initial check
    setTimeout(() => this.triggerScrollEvent(), 500);
  }

  playCard(cardToPlay) {
    if (this.currentPlayingCard === cardToPlay && !cardToPlay.querySelector('video').paused) return;

    // Pause others
    this.cards.forEach(card => {
      const vid = card.querySelector('video');
      if (vid && card !== cardToPlay) {
        vid.pause();
        vid.currentTime = 0;
        card.classList.remove('video-playing');
      }
    });

    // Play target
    const video = cardToPlay.querySelector('video');
    if (video) {
      video.muted = true; // Crucial for autoplay policies
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          cardToPlay.classList.add('video-playing');
          this.currentPlayingCard = cardToPlay;
        }).catch(err => console.log('Autoplay prevented'));
      }
    }
  }

  findAndPlayCenter(visibleEntries) {
    let closestEntry = null;
    let minDistance = Infinity;
    const trackCenter = this.track.getBoundingClientRect().width / 2;

    visibleEntries.forEach(entry => {
      const rect = entry.target.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const relativeCardCenter = (rect.left - trackRect.left) + (rect.width / 2);
      const distance = Math.abs(relativeCardCenter - trackCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestEntry = entry;
      }
    });

    if (closestEntry) {
      this.playCard(closestEntry.target);
    }
  }

  scroll(direction) {
    const cardWidth = this.cards[0].offsetWidth;
    // Get gap from computed style or fallback
    const style = window.getComputedStyle(this.track);
    const gap = parseFloat(style.gap || 16);
    
    this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  startDrag(e) {
    this.isDown = true;
    this.track.classList.add('active');
    this.startX = e.pageX - this.track.offsetLeft;
    this.scrollLeft = this.track.scrollLeft;
    e.preventDefault();
  }

  stopDrag() {
    this.isDown = false;
    this.track.classList.remove('active');
  }

  drag(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.track.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.track.scrollLeft = this.scrollLeft - walk;
  }
  
  triggerScrollEvent() {
     // Manually trigger observer check
     // Creating a tiny scroll wiggle can sometimes force update
     this.track.dispatchEvent(new Event('scroll'));
  }
}

// Initialize on Load and Design Mode interactions
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.vc-wrapper');
  sections.forEach(el => new VideoCarousel(el));
});

// Support for Shopify Design Mode re-rendering
document.addEventListener('shopify:section:load', (e) => {
  const container = e.target.querySelector('.vc-wrapper');
  if (container) new VideoCarousel(container);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
